import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BottomNav = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { key: 'sales', label: 'Entry', path: '/employee/entry', icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v14M5 12h14" /></svg>
    )},
    // { key: 'leaderboard', label: 'Leaderboard', path: '/employee/leaderboard', icon: (
    //   <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.95a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.447a1 1 0 00-.364 1.118l1.287 3.95c.3.921-.755 1.688-1.54 1.118L12 15.347l-3.37 2.447c-.784.57-1.838-.197-1.539-1.118l1.287-3.95a1 1 0 00-.364-1.118L4.645 9.377c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.95z"/>
    //   </svg>
    // )},
    // { key: 'contests', label: 'Contests', path: '/employee/contests', icon: (
    //   <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg>
    // )},
    // { key: 'rewards', label: 'Rewards', path: '/employee/rewards', icon: (
    //   <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4h14V3M5 21v-6h14v6" /></svg>
    // )},
    { key: 'dashboard', label: 'Dashboard', path: '/employee', icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l9-9 9 9M9 21V9h6v12" /></svg>
    )}
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t shadow-lg sm:hidden">
      <div className="max-w-3xl mx-auto px-4 py-2">
        <div className="flex justify-between">
          {items.map(item => {
            const active = location.pathname === item.path;
            return (
              <button
                key={item.key}
                onClick={() => navigate(item.path)}
                className={`flex-1 flex flex-col items-center justify-center py-2 ${active ? 'text-primary-600' : 'text-gray-700'}`}
                aria-current={active ? 'page' : undefined}
              >
                <div className="mb-1">{item.icon}</div>
                <div className="text-xs">{item.label}</div>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;